import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

// _strideColors.scss only defines rubric colors through level 6.
const MAX_COLORED_LEVEL = 6;

@Component({
	selector: 'app-rubric-level-badge',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './rubric-level-badge.component.html',
	styleUrl: './rubric-level-badge.component.scss',
})
export class RubricLevelBadgeComponent {
	public level = input.required<number>();
	public label = input<string>('Level');

	public colorClass = computed(() => `level${Math.min(this.level(), MAX_COLORED_LEVEL)}-color`);
}
